import { Link } from 'react-router-dom';

export default function Resources() {
  return (
    <div>
      <section className="relative overflow-hidden py-16" style={{ background: "var(--gradient-hero)" }}>
        <div className="pointer-events-none absolute inset-0">
          <div className="aurora" />
          <div className="noise" />
        </div>

        <div className="container-ivalue relative">
          <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Resources</div>
          <h1 className="mt-4 text-balance text-4xl font-extrabold tracking-[-0.03em] text-text-primary md:text-6xl">
            Playbooks, catalogs,
            <br />
            and implementation guides
          </h1>
          <p className="mt-5 max-w-3xl text-lg leading-relaxed text-text-secondary">
            A reference library of regulatory frameworks, control catalogs, and technology mapping patterns.
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:items-center">
            <Link
              to="/frameworks/india/dpdpa"
              className="focus-ring sheen inline-flex h-12 items-center justify-center rounded-xl bg-gradient-to-r from-[#10B981] to-[#059669] px-5 text-sm font-semibold text-white transition-transform hover:scale-[1.02] active:scale-[0.98]"
            >
              DPDPA catalog →
            </Link>
            <Link
              to="/technology-mapping"
              className="focus-ring inline-flex h-12 items-center justify-center rounded-xl border border-border-subtle bg-white/5 px-5 text-sm font-semibold text-text-primary transition-colors hover:bg-white/10"
            >
              Technology mapping
            </Link>
          </div>

          <div className="mt-10 grid gap-3 md:grid-cols-3">
            {[
              { t: "Whitepapers", d: "Executive deep dives on RegTech", href: "/resources/whitepapers" },
              { t: "Control Maps", d: "Regulation → control → tech → evidence", href: "/resources/control-maps" },
              { t: "Calculators", d: "ROI, readiness and penalty exposure", href: "/resources/calculators" },
              { t: "Blueprints", d: "Implementation playbooks", href: "/resources/blueprints" },
              { t: "Case Studies", d: "Outcome-driven delivery narratives", href: "/resources/case-studies" },
              { t: "Webinars", d: "Practitioner sessions + workshops", href: "/resources/webinars" },
              { t: "Blog", d: "RegTech engineering field notes", href: "/resources/blog" },
            ].map((c) => (
              <Link
                key={c.t}
                to={c.href}
                className="glass-card sheen block p-5 transition-transform hover:scale-[1.01]"
              >
                <div className="text-sm font-semibold text-text-primary">{c.t}</div>
                <div className="mt-2 text-sm text-text-secondary">{c.d}</div>
                <div className="mt-4 text-sm font-semibold text-[color:var(--text-link)]">Open →</div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-primary py-20">
        <div className="container-ivalue">
          <div className="glass-card p-6">
            <div className="text-xs font-semibold uppercase tracking-wide text-text-muted">Library</div>
            <div className="mt-3 text-sm text-text-secondary">
              Placeholder: we can add search, tags, and downloadable PDFs in Part 6.
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
